var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M16.98 0.287109H1.54426C1.01199 0.287109 0.612793 0.684943 0.612793 1.21539V16.532C0.612793 17.1287 1.01199 17.5265 1.54426 17.5265H9.86095V10.8297H7.59881V8.24377H9.86095V6.32091C9.86095 4.06652 11.2582 2.87303 13.1876 2.87303C14.1191 2.87303 14.984 2.93933 15.1836 3.00564V5.32633H13.7864C12.7219 5.32633 12.5223 5.85677 12.5223 6.58613V8.24377H15.1171L14.7844 10.8297H12.5223V17.5265H16.9135C17.4458 17.5265 17.845 17.1287 17.845 16.5983V1.21539C17.9115 0.684943 17.5123 0.287109 16.98 0.287109Z"}));
}

FacebookInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
